// Chinese Zodiac - Prigimties Archetipas
// Kinų Zodiako sistema pagal gimimo metus
// TEISINGA TVARKA: Žiurkė (0) -> Kiaulė (11)

// Zodiako gyvūnų ciklas (12 metų) - TEISINGA TVARKA
const ZODIAC_ANIMALS = {
  0: {
    animal: 'Žiurkė',
    emoji: '🐀',
    traits: 'Išmintis, greitumas, gebėjimas prisitaikyti, ištekliai',
    character: `Žiurkė yra pirmas ženklas Kinų zodiake ir simbolizuoja naują pradžią. Jūs esate natūralus strategas, gebantis greitai įvertinti situaciją ir priimti teisingus sprendimus. Jūsų protas yra greitas ir aštrus – retai kas gali jus aplenkti. Esate išteklingi ir visada rasite būdą išgyventi ir klestėti. Tačiau kartais galite būti pernelyg savanaudiškas ar manipuliatyvus.`,
    strengths: 'Išmintis, adaptyvumas, ambicingumas, įžvalgumas, ištekliai',
    challenges: 'Savanaudiškumas, manipuliatyvumas, nerimastingumas, godumas',
    career: 'Verslas, finansai, politika, rašymas, tyrimai',
    compatibility: 'Geriausiai sutaria su Drakonu ir Beždžione'
  },
  1: {
    animal: 'Jautis',
    emoji: '🐂',
    traits: 'Stiprumas, patikimumas, kantrybė, metodiškumas',
    character: `Jautis yra vienas stipriausių ir patikimiausių Kinų zodiako ženklų. Jūs esate natūralus statytojas, gebantis kurti tvarius dalykus sunkiu darbu ir kantrybe. Jūsų valia yra nesugriaunama – kai nusprendžiate kažką padaryti, niekas jūsų nesustabdys. Esate lojalus ir ištikimas, vertas pasitikėjimo bet kokioje situacijoje. Tačiau kartais galite būti pernelyg užsispyręs ar nelankstas.`,
    strengths: 'Ištvermė, patikimumas, kantrybė, metodiškumas, lojalumas',
    challenges: 'Užsispyrimas, nelankstumas, per didelis konservatyvumas, lėtumas',
    career: 'Žemės ūkis, statyba, finansai, medicina, administravimas',
    compatibility: 'Geriausiai sutaria su Gaidžiu ir Gyvate'
  },
  2: {
    animal: 'Tigras',
    emoji: '🐅',
    traits: 'Drąsa, galia, aistra, lyderystė',
    character: `Tigras yra vienas galingausių ir drąsiausių Kinų zodiako ženklų. Jūs esate natūralus lyderis, turintis magnetinę trauką ir gebėjimą įkvėpti kitus. Jūsų energija yra užkrečiama – žmonės instinktyviai seka jus. Esate aistringas ir ryžtingas, niekada nebijote kovoti už tai, kuo tikite. Tačiau kartais galite būti pernelyg impulsyvus ar dominuojantis.`,
    strengths: 'Drąsa, lyderystė, aistra, charizma, ryžtingumas',
    challenges: 'Impulsyvumas, dominuojantis, nekantrumas, per didelis pasitikėjimas',
    career: 'Vadovavimas, sportas, pramogos, politika, karjera',
    compatibility: 'Geriausiai sutaria su Arkliu ir Šunimi'
  },
  3: {
    animal: 'Triušis',
    emoji: '🐇',
    traits: 'Elegancija, švelnumas, diplomatiškumas, intuityvumas',
    character: `Triušis yra vienas elegantiškiausių ir subtiliausių Kinų zodiako ženklų. Jūs esate natūralus diplomatas, gebantis surasti harmoniją ir taiką bet kokioje situacijoje. Jūsų intuicija yra nepaprastai stipri – dažnai žinote dalykus, kurių negalite paaiškinti logiškai. Esate švelnus ir rūpestingas, visada siekiantis grožio ir harmonijos. Tačiau kartais galite būti pernelyg jautrus ar vengti konfrontacijos.`,
    strengths: 'Elegancija, diplomatiškumas, intuityvumas, meninė siela, kantrybė',
    challenges: 'Per didelis jautrumas, konflikto vengimas, neapsisprendimas, uždarumas',
    career: 'Menas, dizainas, diplomatija, psichologija, medicina',
    compatibility: 'Geriausiai sutaria su Kiaule ir Avimi'
  },
  4: {
    animal: 'Drakonas',
    emoji: '🐉',
    traits: 'Galia, sėkmė, energija, ambicija',
    character: `Drakonas yra vienintelis mitinis ženklas Kinų zodiake ir simbolizuoja didžiausią galią. Jūs esate gimęs lyderis, turintis begalinę energiją ir ambiciją. Jūsų charizmai niekas negali atsispirti – žmonės natūraliai jus seka. Esate drąsus, originalus ir nebijote eiti prieš srovę. Jūsų visija yra grandiozinė – svajojate dideliais masteliais. Tačiau kartais galite būti pernelyg arogantiškas ar neįvertinantis kitų.`,
    strengths: 'Energija, charizma, ambicija, drąsa, originalumas',
    challenges: 'Arogancija, nekantrumas, per didelis ego, autoritarizmas',
    career: 'Vadovavimas, verslas, pramogos, politika, inovacijos',
    compatibility: 'Geriausiai sutaria su Beždžione ir Žiurke'
  },
  5: {
    animal: 'Gyvatė',
    emoji: '🐍',
    traits: 'Išmintis, paslaptingumas, elegancija, intuicija',
    character: `Gyvatė yra vienas išmintingiausių ir paslaptingiausių Kinų zodiako ženklų. Jūs esate natūralus filosofas, turintis gilų supratimą apie gyvenimo paslaptis. Jūsų intuicija ir įžvalgumas yra nepaprastai stiprūs – matote tai, ko kiti nemato. Esate elegantiškas ir diskretiškas, visada žinantis, kada kalbėti ir kada tylėti. Tačiau kartais galite būti pernelyg uždaras ar manipuliatyvus.`,
    strengths: 'Išmintis, intuicija, elegancija, strateginis mąstymas, kantrybė',
    challenges: 'Uždarumas, nepasitikėjimas, manipuliatyvumas, pavydas',
    career: 'Mokslas, filosofija, psichologija, finansai, medicina',
    compatibility: 'Geriausiai sutaria su Gaidžiu ir Jaučiu'
  },
  6: {
    animal: 'Arklys',
    emoji: '🐎',
    traits: 'Laisvė, energija, aistra, nepriklausomybė',
    character: `Arklys yra vienas laisviausių ir energingiausių Kinų zodiako ženklų. Jūs esate natūralus nuotykių ieškotojas, trokštantis laisvės ir naujų horizontų. Jūsų energija yra užkrečiama – žmonės mėgsta būti šalia jūsų dėl jūsų entuziazmo ir optimizmo. Esate drąsus, spontaniškas ir mėgstate gyvenimą. Tačiau kartais galite būti pernelyg nerimastingas ar neįsipareigojantis.`,
    strengths: 'Energija, entuziazmas, laisvės dvasia, drąsa, socialumas',
    challenges: 'Nerimastingumas, neįsipareigojimas, nekantrumas, savanaudiškumas',
    career: 'Kelionės, sportas, pardavimai, pramogos, žurnalistika',
    compatibility: 'Geriausiai sutaria su Tigru ir Šunimi'
  },
  7: {
    animal: 'Avis',
    emoji: '🐑',
    traits: 'Švelnumas, meninė siela, harmonija, empatija',
    character: `Avis yra vienas švelnių ir kūrybiškiausių Kinų zodiako ženklų. Jūs esate natūralus menininkas, turintis gilų grožio ir harmonijos pojūtį. Jūsų empatija yra nepaprastai stipri – jaučiate kitų emocijas tarsi savo. Esate švelnus ir rūpestingas, visada siekiantis taikos ir harmonijos. Jūsų kūrybiškumas yra begalinis – galite paversti bet ką meno kūriniu. Tačiau kartais galite būti pernelyg jautrus ar priklausomas nuo kitų.`,
    strengths: 'Kūrybiškumas, empatija, švelnumas, harmonija, meninė vizija',
    challenges: 'Per didelis jautrumas, priklausomybė, neapsisprendimas, pesimizmas',
    career: 'Menas, dizainas, muzika, rašymas, socialinis darbas',
    compatibility: 'Geriausiai sutaria su Triušiu ir Kiaule'
  },
  8: {
    animal: 'Beždžionė',
    emoji: '🐵',
    traits: 'Išradingumas, lankstumas, intelektas, smalsumas',
    character: `Beždžionė yra vienas gudrausių ir išradingiausių Kinų zodiako ženklų. Jūs esate natūralus problemų sprendėjas, gebantis rasti išeitį iš bet kokios situacijos. Jūsų protas yra greitas ir lankstus – lengvai prisitaikote prie naujų aplinkybių. Turite puikų humoro jausmą ir gebate įkvėpti kitus savo energija ir optimizmu. Tačiau kartais galite būti pernelyg gudrūs savo labui ar vengti emocinių įsipareigojimų.`,
    strengths: 'Išradingumas, adaptyvumas, socialumas, smalsumas, strateginis mąstymas',
    challenges: 'Nekantrumas, paviršutiniškumas, manipuliatyvumas, sunkumas su įsipareigojimais',
    career: 'Verslas, inovacijos, technologijos, pramogos, tyrimai',
    compatibility: 'Geriausiai sutaria su Drakonu ir Žiurke'
  },
  9: {
    animal: 'Gaidys',
    emoji: '🐓',
    traits: 'Tikslumas, drąsa, sąžiningumas, darbštumas',
    character: `Gaidys yra vienas tiksliausių ir organizuočiausių Kinų zodiako ženklų. Jūs esate natūralus lyderis, turintis aiškią viziją ir gebėjimą ją įgyvendinti. Jūsų dėmesys detalėms yra neprilygstamas – matote tai, ko kiti nepastebi. Esate sąžiningas ir tiesmukas, niekada nebijote pasakyti tiesos. Tačiau kartais galite būti pernelyg kritiškas sau ir kitiems.`,
    strengths: 'Tikslumas, organizuotumas, sąžiningumas, drąsa, darbštumas',
    challenges: 'Perfekcionizmas, kritiškas požiūris, nelankstumas, per didelis pasitikėjimas savimi',
    career: 'Finansai, administravimas, medicina, mokslas, auditas',
    compatibility: 'Geriausiai sutaria su Jaučiu ir Gyvate'
  },
  10: {
    animal: 'Šuo',
    emoji: '🐕',
    traits: 'Lojalumas, ištikimybė, teisingumas, apsauga',
    character: `Šuo yra vienas ištikimiausių ir patikimiausių Kinų zodiako ženklų. Jūs esate natūralus gynėjas, visada pasiruošęs ginti tuos, kuriuos mylite. Jūsų moralinis kompasas yra labai stiprus – žinote, kas teisinga ir kas ne. Esate puikus draugas ir partneris, kurio galima visada pasitikėti. Tačiau kartais galite būti pernelyg nerimastingas ar pesimistiškas.`,
    strengths: 'Lojalumas, sąžiningumas, drąsa, atsargumas, teisingumas',
    challenges: 'Nerimastingumas, pesimizmas, uždarumas, per didelis kritišumas',
    career: 'Teisė, policija, socialinis darbas, medicina, psichologija',
    compatibility: 'Geriausiai sutaria su Tigru ir Arkliu'
  },
  11: {
    animal: 'Kiaulė',
    emoji: '🐷',
    traits: 'Dosnumas, nuoširdumas, malonumas, užuojauta',
    character: `Kiaulė yra vienas dosnių ir nuoširdžiausių Kinų zodiako ženklų. Jūs esate natūralus geradarys, visada pasiruošęs padėti kitiems be jokių sąlygų. Jūsų širdis yra atvira ir pilna meilės. Esate puikus klausytojas ir draugas, kuris visada priima kitus tokius, kokie jie yra. Tačiau kartais galite būti pernelyg patiklus ar lengvai išnaudojamas.`,
    strengths: 'Dosnumas, nuoširdumas, tolerancija, kantrybė, optimizmas',
    challenges: 'Patiklumas, naivumas, per didelis malonumas, materializmas',
    career: 'Labdara, medicina, kulinarija, dizainas, pramogos',
    compatibility: 'Geriausiai sutaria su Tigru ir Triušiu'
  }
};

// Penkių elementų sistema pagal metus
const ELEMENTS_BY_YEAR = {
  0: { name: 'Metalas', traits: 'Ryžtingumas, ambicija, stiprumas' },
  1: { name: 'Metalas', traits: 'Ryžtingumas, ambicija, stiprumas' },
  2: { name: 'Vanduo', traits: 'Intuicija, išmintis, lankstumas' },
  3: { name: 'Vanduo', traits: 'Intuicija, išmintis, lankstumas' },
  4: { name: 'Medis', traits: 'Augimas, kūrybiškumas, gailestingumas' },
  5: { name: 'Medis', traits: 'Augimas, kūrybiškumas, gailestingumas' },
  6: { name: 'Ugnis', traits: 'Aistra, drąsa, energija' },
  7: { name: 'Ugnis', traits: 'Aistra, drąsa, energija' },
  8: { name: 'Žemė', traits: 'Stabilumas, praktiškumas, patikimumas' },
  9: { name: 'Žemė', traits: 'Stabilumas, praktiškumas, patikimumas' }
};

/**
 * Apskaičiuoja Kinų zodiako ženklą pagal gimimo metus
 * TEISINGA FORMULĖ: (metai - 4) % 12
 * 1977: (1977-4) % 12 = 1973 % 12 = 5 = Gyvatė ✓
 */
export function calculateChineseZodiac(year) {
  // Gyvūno indeksas: (metai - 4) mod 12
  const animalIndex = (year - 4) % 12;
  const zodiac = ZODIAC_ANIMALS[animalIndex];
  
  // Elemento indeksas: paskutinis metų skaitmuo
  const lastDigit = year % 10;
  const element = ELEMENTS_BY_YEAR[lastDigit];
  
  // Yin/Yang (lyginiai metai = Yang, nelyginiai = Yin)
  const yinYang = year % 2 === 0 ? 'Yang (Vyriška energija)' : 'Yin (Moteriška energija)';
  
  return {
    animal: zodiac.animal,
    emoji: zodiac.emoji,
    element: element,
    elementName: element.name,
    yinYang: yinYang,
    traits: zodiac.traits,
    character: zodiac.character,
    strengths: zodiac.strengths,
    challenges: zodiac.challenges,
    career: zodiac.career,
    compatibility: zodiac.compatibility,
    fullTitle: `${element.name} ${zodiac.animal} (${yinYang})`
  };
}

/**
 * Gauna trumpą archetipo aprašymą
 */
export function getArchetypeSummary(year) {
  const zodiac = calculateChineseZodiac(year);
  return {
    title: zodiac.fullTitle,
    emoji: zodiac.emoji,
    summary: `${zodiac.emoji} ${zodiac.animal} neša ${zodiac.traits.toLowerCase()} energiją. ${zodiac.element.traits}.`,
    element: zodiac.elementName
  };
}
